export const MAX_DEVTOOLS_STATE_SIZE = 100000; // Threshold for replacing with a placeholder (in bytes)
export const LARGE_DATA_PLACEHOLDER = '<<DATA TOO LARGE>>';
export const PRODUCTION_ENVIRONMENT = 'production';
